module.exports = __webpack_public_path__ + "img/id.36e38fcc.png";